<template>
  <el-dialog
    title="门店定位"
    :visible.sync="dialogVisible"
    custom-class="medium-dialog"
    :close-on-click-modal="false"
    append-to-body open>
    <div class="container">
      <div class="search-box">
        <input
          v-model="searchKey"
          type="search"
          id="search">
        <button @click="searchByHand">搜索</button>
        <button @click="submitAddress" style="margin-left: 2px">确认</button>
        <div class="tip-box" id="searchTip"></div>
      </div>
      <el-amap class="amap-box"
               :amap-manager="amapManager"
               :vid="'amap-vue'"
               :zoom="zoom"
               :plugin="plugin"
               :center="center"
               :events="events">
        <!-- 标记 -->
        <el-amap-marker :position="marker.position"
                        :visible="marker.visible"
                        :draggable="marker.draggable"></el-amap-marker>
      </el-amap>
      <div class="toolbar">
        <span >
          经度:{{ lng }}&nbsp;&nbsp;&nbsp;纬度:{{ lat }}
        </span>
      </div>
    </div>

  </el-dialog>
</template>

<script>

  import {AMapManager, lazyAMapApiLoaderInstance} from 'vue-amap'

  let amapManager = new AMapManager();
  export default {
    data() {
      let self = this;
      return {
        hasInit:false,
        dialogVisible:false,
        address: null,
        searchKey: '',
        amapManager,
        marker: {
          position: [118.853256 , 32.063542],//默认中山陵
          visible: true,
          draggable: false
        },
        searchOption: {
          city: '全国',
          citylimit: true
        },
        center: [118.853256 ,32.063542],//默认中山陵
        zoom: 17,
        lng: 118.853256,
        lat: 32.063542,
        markerEvent:{
          click(e){
            console.log(e);
          }
        },
        events: {
          init() {
            lazyAMapApiLoaderInstance.load().then(() => {
              self.initSearch()
            })
          },
          // 点击获取地址的数据
          click(e) {
            self.marker.position =  [118.853256 , 32.063542];
            let {lng, lat} = e.lnglat;
            self.lng = lng;
            self.lat = lat;
            self.center = [lng, lat];
            self.marker.position  = [lng, lat];
            // 这里通过高德 SDK 完成。
            let geocoder = new AMap.Geocoder({
              radius: 1000,
              extensions: 'all'
            });
            geocoder.getAddress([lng, lat], function (status, result) {
              if (status === 'complete' && result.info === 'OK') {
                if (result && result.regeocode) {
                  self.address = result.regeocode.formattedAddress;
                  self.searchKey = result.regeocode.formattedAddress;
                  self.$nextTick()
                }
              }
            })
          }
        },
        // 一些工具插件
        plugin: []
      }
    },
    methods: {
      show(y,x,bz) {
        //y经度，x纬度，bz备注
        this.initData();
        if (x&& y) {
          let lng = parseFloat(y);
          let lat = parseFloat(x);
          this.lng = lng;
          this.lat = lat;
          this.marker.position = [lng, lat];
          this.center = [lng, lat];
        } else {
          this.address = bz;
          this.searchKey = bz;
          if (this.hasInit) {
            this.searchByHand();
          } else {
            this.initplugin();
            this.hasInit = true;
          }
        }
        this.dialogVisible = true;
      },
      //确认
      submitAddress(){
        if(this.lng==118.853256||this.lat==32.063542){
          this.$message({
            type: 'error',
            message: '需要在地图上标注！'
          });
          return;
        }
        this.$emit('afterLocation',this.lng,this.lat);
        this.dialogVisible = false;
      },
      initSearch() {
        let vm = this;
        let map = this.amapManager.getMap();
        AMapUI.loadUI(['misc/PoiPicker'], function (PoiPicker) {
          var poiPicker = new PoiPicker({
            input: 'search',
            placeSearchOptions: {
              map: map,
              pageSize: 10
            },
            suggestContainer: 'searchTip',
            searchResultsContainer: 'searchTip'
          });
          vm.poiPicker = poiPicker;
          // 监听poi选中信息
          poiPicker.on('poiPicked', function (poiResult) {
            // console.log(poiResult)
            let source = poiResult.source;
            let poi = poiResult.item;
            if (source !== 'search') {
              poiPicker.searchByKeyword(poi.name)
            } else {
              poiPicker.clearSearchResults();
              let lng = poi.location.lng;
              let lat = poi.location.lat;
              let address = poi.cityname + poi.adname + poi.name;
              vm.center = [lng, lat];
              vm.marker.position = [lng, lat];
              vm.lng = lng;
              vm.lat = lat;
              vm.address = address;
              vm.searchKey = address
            }
          })
        })
      },
      searchByHand() {
        if (this.searchKey !== ''&&this.poiPicker) {
          this.poiPicker.searchByKeyword(this.searchKey)
        }
      },
      initData(){
        //初始化数据
        this.lng=118.853256;
        this.lat=32.063542;
        this.address ='';
        this.searchKey = '';
        this.plugin = [];
      },
      //初始化插件
      initplugin(){
        let self = this;
        this.plugin=[
          {
            // 定位
            enableHighAccuracy: true,//是否使用高精度定位，默认:true
            timeout: 100,          //超过10秒后停止定位，默认：无穷大
            maximumAge: 0,           //定位结果缓存0毫秒，默认：0
            convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
            showButton: true,        //显示定位按钮，默认：true
            buttonPosition: 'RB',    //定位按钮停靠位置，默认：'LB'，左下角
            showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
            showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
            panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
            zoomToAccuracy: true,//定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：f
            extensions: 'all',
            pName: 'Geolocation',
            events: {
              init(o) {
                // o是高德地图定位插件实例
                o.getCurrentPosition((status, result) => {
                  // if (result && result.position) {
                  //   //设置经度
                  //   self.lng = result.position.lng;
                  //   // 设置维度
                  //   self.lat = result.position.lat;
                  //   // 设置坐标
                  //   self.center = [self.lng, self.lat];
                  //   //展示坐标
                  //   self.marker.position=[self.lng, self.lat];
                  //   //展示地址
                  //   self.address =result.formattedAddress;
                  //   self.searchKey =result.formattedAddress;
                  // 页面渲染好后
                  self.searchByHand();

                  // }
                })
              },
              /*click(e){
              console.log(e);
            }*/
            }
          },
          /*     {
                 // 工具栏
                 pName: 'ToolBar',
                 events: {
                   init(instance) {
                     console.log(instance);
                   }
                 }
               },
               {
                 // 鹰眼
                 pName: 'OverView',
                 events: {
                   init(instance) {
                     console.log(instance);
                   }
                 }
               },
               {
                 // 地图类型
                 pName: 'MapType',
                 defaultType: 0,
                 events: {
                   init(instance) {
                     console.log(instance);
                   }
                 }
               },*/
          {
            // 搜索
            pName: 'PlaceSearch',
            events: {
              /*init(instance) {
                console.log(instance)
              }*/
            }
          }]

      }
    },
    mounted() {
    },
  }


</script>

<style>
  .container {
    width:100%;
    height: 700px;
    position: relative;
    left: 0;
    top: 10px;
    border: 1px solid #999;
  }

  .search-box {
    position: absolute;
    z-index: 5;
    width: 70%;
    left: 13%;
    top: 10px;
    height: 30px;
  }

  .search-box input {
    float: left;
    width: 59%;
    height: 100%;
    border: 1px solid #30ccc1;
    padding: 0 8px;
    outline: none;
  }

  .search-box button {
    float: left;
    width: 20%;
    height: 100%;
    background: #30ccc1;
    border: 1px solid #30ccc1;
    color: #fff;
    outline: none;
  }

  .tip-box {
    width: 100%;
    max-height: 260px;
    position: absolute;
    top: 30px;
    overflow-y: auto;
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/set/dept/Location.vue